//@ts-check
function requiredParam(param, typeOfParam) {
  const requiredParamError = new Error(`Required parameter, "${param}" is missing.`);
  // preserve original stack trace
  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(requiredParamError, requiredParam);
  }
  throw requiredParamError;
  let toReturn = null;
  switch (typeOfParam) {
    case String:
      toReturn = "";
    case Number:
      toReturn = -1;
    case Boolean:
      toReturn = false;
    case Array:
      toReturn = [];
    default:
      toReturn = {};
  }
  return toReturn;
}

module.exports = requiredParam;



// WEBPACK FOOTER //
// ./modules/toolbox/requiredParams.ts